import { isBrowser } from '../utils/environment'
import { uniqueString } from '../utils/string'

const _handlers = uniqueString('PageVisibiltyBehavior_handlers')
const _onChange = uniqueString('PageVisibiltyBehavior_onChange')
const _listening = uniqueString('PageVisibiltyBehavior_listening')

export default class PageVisibilityBehavior {
  constructor(onChange) {
    if (!PageVisibilityBehavior[_handlers]) {
      PageVisibilityBehavior[_handlers] = new Set()
      PageVisibilityBehavior[_listening] = false
    }
    if (!isBrowser()) return

    this[_onChange] = onChange || function () {}

    this.start()
  }

  start() {
    if (PageVisibilityBehavior[_handlers].has(this)) return

    PageVisibilityBehavior[_handlers].add(this)
    PageVisibilityBehavior.start()
  }

  stop() {
    PageVisibilityBehavior[_handlers].remove(this)

    if (!PageVisibilityBehavior[_handlers].size) {
      PageVisibilityBehavior.stop()
    }
  }

  static start() {
    if (PageVisibilityBehavior[_listening]) return

    const changeBehaviors = PageVisibilityBehavior[_handlers]

    if (!changeBehaviors || !changeBehaviors.size) return

    document.addEventListener('visibilitychange', PageVisibilityBehavior._onVisiblityChange)

    PageVisibilityBehavior[_listening] = true
  }

  static stop() {
    if (!PageVisibilityBehavior[_listening]) return

    document.removeEventListener('visibilitychange', PageVisibilityBehavior._onVisiblityChange)

    PageVisibilityBehavior[_listening] = false
  }

  static _onVisiblityChange() {
    const hidden = document.visibilityState === 'hidden'

    /* eslint-disable no-empty */
    PageVisibilityBehavior[_handlers].forEach((handler) => {
      try {
        handler[_onChange](hidden)
      } catch (error) {}
    })
    /* eslint-enable no-empty */
  }
}
